module.exports = __webpack_public_path__ + "static/media/uno.3a3ff03f.jpg";